export const getPublishedTemplates = (templates) =>
	(templates || []).filter(t => t.status?.toUpperCase() === 'PUBLISHED');